    /**
     * Takes a `fullName` string, returns an object with `firstName` and `lastName`.
     * You can make this as fancy as you like (handle middle names, suffixes, etc.).
     */
    export function parseFullName(fullName: string): { firstName: string; lastName: string } {
        // Basic naive split on whitespace
        const parts = fullName.trim().split(/\s+/);
        const firstName = parts[0] || '';
        const lastName = parts.slice(1).join(' ') || '';
        return { firstName, lastName };
    }